import { LoadingBar } from 'view-design'
import router from './router'
import store from './store'
import createRoutes from '@/utils/createRoutes'
import { getDocumentTitle, resetTokenAndClearUser } from './utils'
import request from '@/utils/request'

// 是否有菜单数据
let hasMenus = false
router.beforeEach(async (to, from, next) => {
    document.title = getDocumentTitle(to.meta.title);
    LoadingBar.start();

    if (localStorage.getItem('token') && localStorage.getItem('userId') && localStorage.getItem('workshop')) {
        // 已登录，访问登录页 → 重定向到首页（使用 replace 避免历史记录）
        if (to.path === '/login') {
            next({ path: '/', replace: true });
        } 
        else if (hasMenus) {
            next();
        } 
        else {
            try {
                const data = await request.get('/api/Menu/GetHomeMenu', {
                    params: { userId: parseInt(localStorage.getItem("userId")) }
                });
                var menuData = data.data;
                menuData.unshift({
                    value: 0,
                    name: "home",
                    title: "主页",
                    expand: true,
                    Checked: false,
                    size: 0,
                    url: "home",
                    menuIcon: "home.png",
                    text: "主页"
                });
                store.commit('setMenus', menuData);
                const routes = createRoutes(menuData);
                router.addRoutes(routes);
                hasMenus = true;
                // 关键修改：使用 replace 保留完整目标路径，避免重定向错误
                next({ path: to.fullPath, replace: true });
            } 
            catch (error) {
                resetTokenAndClearUser();
                // 登录失效，跳转到登录页并携带原目标路径
                next({ path: '/login', query: { redirect: to.fullPath }, replace: true });
            }
        }
    } 
    else {
        hasMenus = false;
        // 未登录时允许访问的白名单页面
        if (to.path === '/login' ||
            to.path === '/productintroduction' ||
            to.path === '/documentshare' ||
            to.path === '/supplierreconciliationlistshare' ||
            to.path === '/customerreconciliationlistshare') {
            next();
        } 
        else {
            // 其他页面重定向到产品介绍页，并保留原目标路径
            next({ path: '/productintroduction', query: { redirect: to.fullPath }, replace: true });
        }
    }
});

router.afterEach(() => {
    LoadingBar.finish();
});
